var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("convert-to-credit-note-title"))),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c("p", [_vm._v(_vm._s(_vm.message))]),
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("convert-to-credit-note-auto-settle") },
                model: {
                  value: _vm.autoSettleCreditNote,
                  callback: function ($$v) {
                    _vm.autoSettleCreditNote = $$v
                  },
                  expression: "autoSettleCreditNote",
                },
              }),
              _c("p", { staticClass: "option-description" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ct("convert-to-credit-note-auto-settle-description")
                  )
                ),
              ]),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check", disabled: _vm.converting },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }